/*
 * Powiększanie zdjęć produktu na telefonie.
 * Stuknięcie w zdjęcie w galerii -> pełny ekran: zdjęcia przesuwane w bok, powiększanie dwoma palcami
 * albo podwójnym stuknięciem, przeciąganie powiększonego jednym palcem. Zamykanie: X, przycisk
 * „wstecz" telefonu albo Esc. Na komputerze nic się nie zmienia (galeria bez powiększania).
 */
(function () {
  if (window.__fkxImageZoom) return;
  window.__fkxImageZoom = true;

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var MAX_SCALE = 4;
  var TAP_SCALE = 2.5;
  var IMG_WIDTH = 2048; // dość na powiększenie x3–4 na telefonie, bez ściągania oryginałów po kilka MB

  var lang = (document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
  var TXT = {
    pl: { close: 'zamknij', image: 'zdjęcie' },
    en: { close: 'close', image: 'image' },
    es: { close: 'cerrar', image: 'imagen' }
  }[lang] || { close: 'zamknij', image: 'zdjęcie' };

  var root, track, counter, slides = [], current = 0, historyOpen = false;
  var savedOverflow = '';

  function injectCss() {
    if (document.getElementById('fkx-iz-css')) return;
    var st = document.createElement('style');
    st.id = 'fkx-iz-css';
    st.textContent =
      '.fkx-iz{position:fixed;inset:0;z-index:2147482000;background:#000;color:#fff;overscroll-behavior:contain}' +
      '.fkx-iz__track{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
      '.fkx-iz__track::-webkit-scrollbar{display:none}' +
      '.fkx-iz--zoomed .fkx-iz__track{overflow-x:hidden}' +
      '.fkx-iz__slide{position:relative;flex:0 0 100%;height:100%;overflow:hidden;scroll-snap-align:center;scroll-snap-stop:always}' +
      // pan-x: przesuwanie w bok robi przeglądarka, szczypanie trafia do skryptu
      '.fkx-iz__img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;transform-origin:0 0;touch-action:pan-x;user-select:none;-webkit-user-select:none;-webkit-user-drag:none}' +
      '.fkx-iz--zoomed .fkx-iz__img{touch-action:none}' +
      '.fkx-iz__img.is-anim{transition:transform .22s ease}' +
      '.fkx-iz__close{position:absolute;top:calc(env(safe-area-inset-top) + 12px);right:calc(env(safe-area-inset-right) + 12px);z-index:2;width:44px;height:44px;display:flex;align-items:center;justify-content:center;padding:0;border:2px solid rgba(255,255,255,.85);border-radius:0;background:rgba(0,0,0,.55);color:#fff;box-shadow:3px 3px 0 rgba(0,0,0,.6);cursor:pointer}' +
      '.fkx-iz__close svg{width:18px;height:18px;display:block}' +
      '.fkx-iz__count{position:absolute;left:50%;bottom:calc(env(safe-area-inset-bottom) + 16px);transform:translateX(-50%);z-index:2;padding:.3em .8em;background:rgba(0,0,0,.55);font-size:14px;letter-spacing:.06em;pointer-events:none}' +
      '.fkx-iz__count:empty{display:none}';
    document.head.appendChild(st);
  }

  function sized(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + IMG_WIDTH;
  }

  /* ---------- powiększanie jednego zdjęcia ---------- */
  function Zoom(img, slide) {
    this.img = img;
    this.slide = slide;
    this.s = 1;
    this.x = 0;
    this.y = 0;
    this.pts = {};
    this.lastTap = 0;
    this.lastTapX = 0;
    this.lastTapY = 0;
    var z = this;
    img.addEventListener('pointerdown', function (e) { z.down(e); });
    img.addEventListener('pointermove', function (e) { z.move(e); });
    img.addEventListener('pointerup', function (e) { z.up(e); });
    img.addEventListener('pointercancel', function (e) { z.up(e, true); });
  }

  Zoom.prototype.box = function () {
    return this.slide.getBoundingClientRect();
  };

  Zoom.prototype.apply = function (anim) {
    var r = this.box();
    // powiększony obraz nie odjeżdża poza krawędzie
    this.x = Math.min(0, Math.max(r.width - r.width * this.s, this.x));
    this.y = Math.min(0, Math.max(r.height - r.height * this.s, this.y));
    this.img.classList.toggle('is-anim', !!anim);
    this.img.style.transform = this.s > 1.001 ? 'translate(' + this.x + 'px,' + this.y + 'px) scale(' + this.s + ')' : '';
    root.classList.toggle('fkx-iz--zoomed', this.s > 1.001);
  };

  Zoom.prototype.reset = function (anim) {
    this.s = 1;
    this.x = this.y = 0;
    this.pts = {};
    this.apply(anim);
  };

  Zoom.prototype.zoomAt = function (s, px, py, anim) {
    // punkt pod palcem zostaje w miejscu
    var k = s / this.s;
    this.x = px - (px - this.x) * k;
    this.y = py - (py - this.y) * k;
    this.s = s;
    this.apply(anim);
  };

  Zoom.prototype.local = function (e) {
    var r = this.box();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  Zoom.prototype.pinch = function () {
    var ids = Object.keys(this.pts);
    var a = this.pts[ids[0]], b = this.pts[ids[1]];
    return { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
  };

  Zoom.prototype.down = function (e) {
    this.pts[e.pointerId] = this.local(e);
    var n = Object.keys(this.pts).length;
    if (n === 2) {
      e.preventDefault();
      this.img.setPointerCapture && this.img.setPointerCapture(e.pointerId);
      var p = this.pinch();
      this.start = { s: this.s, x: this.x, y: this.y, d: p.d, mx: p.mx, my: p.my };
      root.classList.add('fkx-iz--zoomed'); // od razu bez przewijania w bok, żeby nie walczyło ze szczypaniem
    } else if (n === 1 && this.s > 1.001) {
      this.img.setPointerCapture && this.img.setPointerCapture(e.pointerId);
      this.start = { x: this.x, y: this.y, px: this.pts[e.pointerId].x, py: this.pts[e.pointerId].y };
    }
    this.moved = false;
  };

  Zoom.prototype.move = function (e) {
    if (!this.pts[e.pointerId]) return;
    this.pts[e.pointerId] = this.local(e);
    var n = Object.keys(this.pts).length;
    if (n >= 2 && this.start && this.start.d) {
      e.preventDefault();
      var p = this.pinch();
      var s = Math.min(MAX_SCALE, Math.max(1, this.start.s * (p.d / this.start.d)));
      // punkt obrazu, który był pod środkiem palców, idzie za środkiem palców
      var ix = (this.start.mx - this.start.x) / this.start.s;
      var iy = (this.start.my - this.start.y) / this.start.s;
      this.s = s;
      this.x = p.mx - ix * s;
      this.y = p.my - iy * s;
      this.apply(false);
      this.moved = true;
    } else if (n === 1 && this.s > 1.001 && this.start && this.start.px !== undefined) {
      e.preventDefault();
      var q = this.pts[e.pointerId];
      this.x = this.start.x + (q.x - this.start.px);
      this.y = this.start.y + (q.y - this.start.py);
      this.apply(false);
      if (Math.abs(q.x - this.start.px) + Math.abs(q.y - this.start.py) > 8) this.moved = true;
    } else if (n === 1) {
      this.moved = true; // przesuwanie w bok (robi to przeglądarka)
    }
  };

  Zoom.prototype.up = function (e, cancel) {
    var pt = this.pts[e.pointerId] || this.local(e);
    delete this.pts[e.pointerId];
    var n = Object.keys(this.pts).length;
    if (n === 1) {
      // z dwóch palców został jeden: dalej przeciąganie od tego miejsca
      var id = Object.keys(this.pts)[0];
      this.start = { x: this.x, y: this.y, px: this.pts[id].x, py: this.pts[id].y };
      return;
    }
    if (n > 0) return;
    if (this.s < 1.05) this.reset(true);
    if (cancel || this.moved) return;
    // podwójne stuknięcie: powiększ w tym miejscu / wróć do całości
    var now = Date.now();
    if (now - this.lastTap < 320 && Math.abs(pt.x - this.lastTapX) < 30 && Math.abs(pt.y - this.lastTapY) < 30) {
      this.lastTap = 0;
      if (this.s > 1.001) this.reset(true);
      else this.zoomAt(TAP_SCALE, pt.x, pt.y, true);
    } else {
      this.lastTap = now;
      this.lastTapX = pt.x;
      this.lastTapY = pt.y;
    }
  };

  /* ---------- przeglądarka ---------- */
  function build(items, start) {
    injectCss();
    root = document.createElement('div');
    root.className = 'fkx-iz';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<div class="fkx-iz__track"></div>' +
      '<button type="button" class="fkx-iz__close" aria-label="' + TXT.close + '">' +
      '<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M2 2l14 14M16 2L2 16" stroke="currentColor" stroke-width="2.4" fill="none"/></svg></button>' +
      '<div class="fkx-iz__count" aria-live="polite"></div>';
    track = root.querySelector('.fkx-iz__track');
    counter = root.querySelector('.fkx-iz__count');
    slides = items.map(function (it, i) {
      var slide = document.createElement('div');
      slide.className = 'fkx-iz__slide';
      var img = document.createElement('img');
      img.className = 'fkx-iz__img';
      img.alt = it.alt || TXT.image + ' ' + (i + 1);
      img.decoding = 'async';
      img.draggable = false;
      // od razu tylko otwarte zdjęcie i sąsiednie, dalsze dopiero przy przewijaniu
      if (Math.abs(i - start) > 1) img.loading = 'lazy';
      img.src = it.src;
      slide.appendChild(img);
      track.appendChild(slide);
      return { el: slide, zoom: new Zoom(img, slide) };
    });
    root.querySelector('.fkx-iz__close').addEventListener('click', function () { close(); });
    track.addEventListener('scroll', onScroll, { passive: true });
    document.body.appendChild(root);
    track.scrollLeft = start * track.clientWidth;
    current = start;
    updateCount();
  }

  function onScroll() {
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (i === current) return;
    if (slides[current]) slides[current].zoom.reset(false);
    current = i;
    updateCount();
  }

  function updateCount() {
    counter.textContent = slides.length > 1 ? current + 1 + ' / ' + slides.length : '';
  }

  function open(items, start) {
    if (root) return;
    build(items, start);
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    // „wstecz" w telefonie zamyka podgląd zamiast wychodzić ze strony
    try {
      history.pushState({ fkxIz: true }, '');
      historyOpen = true;
    } catch (e) {}
    document.addEventListener('keydown', onKey);
    root.querySelector('.fkx-iz__close').focus({ preventScroll: true });
  }

  function close(fromHistory) {
    if (!root) return;
    document.removeEventListener('keydown', onKey);
    root.remove();
    root = track = counter = null;
    slides = [];
    document.documentElement.style.overflow = savedOverflow;
    if (historyOpen && !fromHistory) {
      historyOpen = false;
      history.back();
    }
    historyOpen = false;
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  window.addEventListener('popstate', function () {
    if (root) close(true);
  });

  /* ---------- stuknięcie w zdjęcie w galerii produktu ---------- */
  document.addEventListener('click', function (e) {
    if (!MOBILE.matches || root) return;
    var li = e.target.closest && e.target.closest('.product__media-list .product__media-item');
    if (!li || li.classList.contains('product__media-item--full')) return; // wideo / model 3D bez zmian
    var list = li.parentElement;
    var all = Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (x) {
      return !x.classList.contains('product__media-item--full') && x.offsetParent !== null && x.getAttribute('data-media-src');
    });
    var start = all.indexOf(li);
    if (start < 0) return;
    e.preventDefault();
    open(all.map(function (x) {
      return { src: sized(x.getAttribute('data-media-src')), alt: x.getAttribute('data-media-alt') || '' };
    }), start);
  });
})();
